import React,{useImperativeHandle, forwardRef, useState, useEffect} from 'react';
import { Modal, Form, Button,Upload, Row, Col, Input, Select, TreeSelect, message } from 'antd';
import * as User from '@/common/api/user';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { getAuthorization } from '@/common/js/utils';
import {currentUserDeptTree} from '@/common/api/dept';
import './index.css'
const { TextArea } = Input;
function PersonalInfo (props, ref) {
    const { Option } = Select;
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [treeData, setTreeData] = useState([])
    const [userInfo, setUserInfo] = useState({});
    const [imgUrl, setImgUrl] = useState('');
    const [uploadLoading, setUploadLoading] = useState(false);
    const [headers] = useState(getAuthorization());
    const [width] = useState('200px');
    const layout = {
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 10
        }
    }
    const layout24 = {
        labelCol: {
            span: 3
        },
        wrapperCol: {
            span: 18
        }
    }
    // 表单显示
    useImperativeHandle(ref, () => ({
        showModal: ()=> {
            treeList()
            form.resetFields()
            setVisible(true);
        }
    }))
    // 模态框关闭
    const handleCancel = () => {
        form.resetFields()
        setVisible(false)
    }
    // 表单提交事件
    const handleSubmit = () => {
        form.validateFields().then((values) => {
            setLoading(true)
            const params = {...values}
            if(userInfo && userInfo.id){
                params.id = userInfo.id
            }
            User.updateUserInfo(params).then(res => {
                if (res.code === 0) {
                    message.success('保存成功')
                    form.resetFields()
                    setLoading(false)
                    props.initAvatar()
                    setVisible(false)
                }
            })
        })
    }
    // 模态框底部按钮
    const modalButton = [
        <Button key="submits" loading={loading} onClick={handleSubmit} type="primary">保存</Button>,
        <Button key="back" onClick={handleCancel}>取消</Button>
    ]
    // 模态框配置项
    const modalOptions = {
        width: 1100,
        footer: modalButton,
        onCancel: handleCancel,
        title: '个人信息',
        visible: visible,
        className: 'personalinfo'
    }
    // 获取用户信息
    function handleUserInfo() {
        User.getUserDetailInfo().then(res => {
            const data = res.data
            // if (data.roleList && data.roleList.length > 0) {
            //     const nameArr = []
            //     data.roleList.map(item => {
            //         nameArr.push(item.roleName)
            //     })
            //     data.newRoleList = nameArr.join(',')
            // }
            form.setFieldsValue({...data});
            if (data && data.avatar) {
                const oldEscape = data.avatar.replace(/\\/g, '用户个人头像')
                const escapeCharacter = '/'
                const escape = oldEscape.replace(/用户个人头像/g, `${escapeCharacter}`)
                const avatar = JSON.parse(escape)
                if (avatar.fileUrl) {
                    setImgUrl(`${React.$util.getBaseUrl()}/file/files${avatar.fileUrl}`)
                }
            }
            setUserInfo({...data})
        })
    }
    /** */
    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
    // 组织数据
    const treeList = () => {
        currentUserDeptTree().then(res => {
            if (res.code === 0 && res.data.length > 0 ) {
                setTreeData(React.$util.replaceTreeFields(res.data))
            }
        })
    }
    // 异步加载组织树
    const onLoadData = (record) => {
        // return new Promise(resolve => {
        //     if (!record) {
        //         resolve()
        //         return;
        //     }
        //     if (record.childNum && record.childNum > 0) {
        //         let childrenList = []
        //         getDeptList({parentId: record.id}).then(res => {
        //             if(res.code === 0){
        //                 res.data.map((item) => {
        //                     item.key = item.id
        //                     item.title = item.name
        //                     item.value = item.id
        //                     if (item.childNum === 0 ) {
        //                         item.isLeaf = true
        //                     }
        //                     childrenList.push(item)
        //                 })
        //                 setTreeData(treeList =>
        //                     React.$util.updateTreeData(treeList, record.id, childrenList)
        //                 )
        //                 resolve()
        //             }
        //         })
        //     }
        // })
    }
    /*
     * 上传头像
    */
    const handleChange = info => {
        if (info.file.status === 'uploading') {
          setUploadLoading(true)
          return;
        }
        if (info.file.status === 'done') {
          getBase64(info.file.originFileObj, imageUrl =>{
            setImgUrl(imageUrl)
            setUploadLoading(false)
          });
          const fileInfo = info.file.response.data
          const oldEscape = (JSON.stringify(fileInfo)).replace(/\\{2}/g, '用户个人头像')
          const escapeCharacter = '\\'
          const escape = oldEscape.replace(/用户个人头像/g, `${escapeCharacter}`)
          form.setFieldsValue({
            'avatar': escape
          })
        }
    }
    const uploadButton = (
        <div>
          {uploadLoading ? <LoadingOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8 }}>上传头像</div>
        </div>
      );
    useEffect(() => {
        handleUserInfo()
    }, [])
    useEffect(() => {
        if (visible === true) {
            setUserInfo({})
            handleUserInfo()
        }
    }, [visible])
    return (
        <Modal {...modalOptions}>
        <Form form={form} {...layout} labelAlign="right" name="form">
            <Row>
                <Col span="18">
                    <Row>
                        <Col span="12">
                            <Form.Item label="账号" name="userName" rules={[{ required: true, message: '账号不能为空'}]}>
                                <Input disabled={true} placeholder="请输入账号" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="昵称" name="nickName" rules={[{ required: true, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入昵称" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="真实姓名" name="realName" rules={[{ required: true, message: '账号不能为空'}]}>
                                <Input disabled={false} placeholder="请输入账号" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="性别" name="gender" rules={[{ required: true, message: '昵称不能为空'}]}>
                                {/* <Input disabled={false} placeholder="请输入昵称" style={{width: width}}/> */}
                                <Select
                                    placeholder="性别不能为空"
                                    allowClear
                                    style={{width: width}}
                                >
                                    <Option value={1}>男</Option>
                                    <Option value={2}>女</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="生日" name="birthday" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入生日" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="部门" name="deptId" rules={[{ required: true, message: '昵称不能为空'}]}>
                                <TreeSelect
                                    disabled={true}
                                    style={{width: width}}
                                    // loadData={onLoadData}
                                    placeholder="请选择部门"
                                    treeData={treeData}
                                />
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="状态" name="status" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Select
                                    placeholder="状态不能为空"
                                    allowClear
                                    style={{width: width}}
                                >
                                    <Option value={0}>禁用</Option>
                                    <Option value={1}>正常</Option>
                                    <Option value={2}>锁定</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="排序" name="seq" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入排序" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="手机号" name="mobile" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入手机号" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="座机" name="phone" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入座机" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="工号" name="jobNum" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={true} placeholder="请输入工号" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="卡号" name="cardNo" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入卡号" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="工作地址" name="jobAddr" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入工作地址" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="12">
                            <Form.Item label="家庭地址" name="homeAddr" rules={[{ required: false, message: '昵称不能为空'}]}>
                                <Input disabled={false} placeholder="请输入家庭地址" style={{width: width}}/>
                            </Form.Item>
                        </Col>
                        <Col span="24" >
                            <Form.Item label="备注" name="remark" {...layout24} rules={[{ required: false, message: '昵称不能为空'}]}>
                                <TextArea autoSize={{ minRows: 2, maxRows: 6 }} placeholder="请输入备注"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
                <Col span="6">
                    <Col span="24">
                        <Form.Item label="头像" name="avatar">
                            <Upload
                                action={`${React.$util.getBaseUrl()}/file/upload`}
                                className="avatar-uploader"
                                headers={headers}
                                listType="picture-card"
                                name="file"
                                onChange={handleChange}
                                showUploadList={false}
                            >
                            {imgUrl ? <img alt="avatar" src={imgUrl} style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col spann="24">
                        <Form.Item label="职位" name="position" rules={[{ required: false, message: '昵称不能为空'}]}>
                            <Input disabled={false} placeholder="请输入职位" style={{width: width}}/>
                        </Form.Item>
                    </Col>
                    <Col span="24"></Col>
                    <Col span="24">
                    <Col spann="24">
                        <Form.Item label="邮箱" name="email" rules={[{ required: false, message: '昵称不能为空'}]}>
                            <Input disabled={false} placeholder="请输入邮箱" style={{width: width}}/>
                        </Form.Item>
                    </Col>
                    </Col>
                </Col>
            </Row>
        </Form>
    </Modal>
    )
}
export default forwardRef(PersonalInfo)
